import AuthService from '../../services/auth.service'
import { handleErrors } from '../../utils/request.helper'
import UsersService from '../../services/users.service'
import { openNotificationWithIcon } from '../../utils/notification.helper'
import { authPersistActions } from '../slices/auth.persist.slice'
import baseApi from '../apis/base.api'
import { ASSIGNMENT_TAG } from '../apis/utils/tags'

/***************************************** INITIAL STATE ********************************************/
export const INITIAL_STATE = {}

/******************************************** ACTIONS ***********************************************/
export const actions = {
    changePassword: (oldPassword, newPassword) => async () => {
        return await handleErrors(async () => {
            await AuthService.changePassword(oldPassword, newPassword)
            openNotificationWithIcon('success', 'Password changed successfully')
            return true
        })
    },
    impersonate: data => async dispatch => {
        return await handleErrors(async () => {
            await AuthService.impersonate(data)

            dispatch(baseApi.util.invalidateTags([{ type: ASSIGNMENT_TAG, id: 'LIST' }]))
            dispatch(authPersistActions.setImpersonated(true))

            return true
        })
    },
    generateOtp: data => async () => {
        return await handleErrors(async () => {
            return await AuthService.generateOtp(data)
        })
    },
    resetUserOtp: data => async () => {
        return await handleErrors(async () => {
            return await UsersService.resetUserOtp(data)
        })
    },
    verifyOtp: data => async () => {
        return await handleErrors(async () => {
            return await AuthService.verifyOtp(data)
        })
    },
}

/******************************************* REDUCER ************************************************/
const adminReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        default:
            return state
    }
}

export default adminReducer
